import { Component, inject } from '@angular/core';
import { BaseModalComponent } from '../../../../models/base/base-modal.component';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { EulaAPI } from '../../../../api/eula-api';
import { PortalService } from '../../../../services/portal/portal.service';
import { ToastService } from '../../../../services/toast-service';
import { BehaviorSubject, forkJoin, Observable, timer } from 'rxjs';
import { finalize, switchMap, take } from 'rxjs/operators';

@Component({
  selector: 'app-eula-modal',
  templateUrl: './eula-modal.component.html',
  styleUrls: ['./eula-modal.component.scss', '../base-action-modal/base-action-modal.component.scss']
})
export class EulaModalComponent extends BaseModalComponent {
  public ignoreEscape: boolean = false;

  private eulaAPI = inject(EulaAPI);
  private portalService = inject(PortalService);
  private toastService = inject(ToastService);

  constructor(protected activeModal: NgbActiveModal) {
    super(activeModal);
  }

  public isLoading = false;

  private _eulaText = new BehaviorSubject<string>('');
  public eulaText$: Observable<string> = this._eulaText as Observable<string>;

  setupBindings(): void {}

  setupViews(): void {
    this.isLoading = true;
    this.portalService.portalTypeId$
      .pipe(
        take(1),
        // Using timer to ensure the shimmers are shown for at least 250ms
        switchMap(portalId => forkJoin([this.eulaAPI.getEulaByPortalTypeId(portalId), timer(250)])),
        finalize(() => (this.isLoading = false))
      )
      .subscribe({
        next: ([eula]) => {
          this._eulaText.next(eula.licenceAgreement);
        },
        error: err => {
          this.toastService.publishError(err);
        }
      });
  }
}
